<template>
  <v-row class="fill-height">
    <v-col class="fill-height">
      <!-- Options -->
      <v-card class="my-page2-card pa-2" elevation="4" dark>
        <v-row>
          <v-col>
            <v-combobox
              label="類別"
              v-model="optionSelected1"
              :items="!isUpdating2 ? components.list : []"
              @change="handleOnChangeOption1"
            ></v-combobox>
          </v-col>
          <v-col>
            <v-combobox
              label="品牌"
              v-model="optionSelected2"
              :items="options2"
              @change="handleOnChangeOption2"
              :loading="isUpdating2"
            ></v-combobox>
          </v-col>
          <v-col>
            <v-combobox
              label="系列"
              v-model="optionSelected3"
              :items="options3"
              :loading="isUpdating2"
            ></v-combobox>
          </v-col>
        </v-row>
      </v-card>
      <!-- Table -->
      <v-row>
        <v-col class="pb-0">
          <v-data-table
            :headers="headers"
            item-key="d_id"
            :items="!isUpdating2 ? listByTwoOptions : []"
            class="elevation-4 my-page2-table"
            :search="tableSearch"
            :loading="isUpdating2"
            loading-text="資料更新中..."
            no-data-text="暫無資料"
            no-results-text="沒有匹配的資料"
            dark
            :items-per-page="-1"
            :mobile-breakpoint="1"
          >
            <template v-slot:top>
              <v-row dense>
                <v-col cols="7">
                  <v-text-field
                    v-model="tableSearch"
                    label="快速搜尋"
                  ></v-text-field>
                </v-col>
                <v-col class="text-end">
                  <v-chip
                    class="mt-4"
                    color="amber"
                    text-color="black"
                    style="font-size:22px;"
                    @click="changeToPage3"
                  >
                    報價單
                    <v-avatar right class="white">
                      <strong>{{ carts.length }}</strong>
                    </v-avatar>
                  </v-chip>
                  <!-- <v-icon>
                    mdi-package-down
                  </v-icon> -->
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.rf="{ item }">
              <v-chip :color="getColor(item.rf)">{{ item.rf }}</v-chip>
            </template>
            <template v-slot:item.ap="{ item }">
              <v-chip :color="getColor(item.ap)">{{ item.ap }}%</v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-row class="pa-0 ma-0">
                <v-col class="pa-0 ma-0">
                  <v-btn
                    v-if="!isClickSell"
                    :color="getColorForCart(item)"
                    @click="handleOnSellItem(item)"
                    text
                    class="pa-0 ma-0"
                  >
                    <v-icon>
                      mdi-package-down
                    </v-icon>
                    <strong>加入<br />報價</strong>
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0 text-end">
          <div class="my-page3-tbft-append">
            <v-chip
              class="mt-4"
              color="amber"
              text-color="black"
              style="font-size:22px;"
              @click="changeToPage3"
            >
              報價單結算
              <v-avatar right class="white">
                <strong>{{ carts.length }}</strong>
              </v-avatar>
            </v-chip>
            <!-- <v-icon>
              mdi-package-down
            </v-icon> -->
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
  data: () => {
    return {
      // #region Component Options
      optionSelected1: '',
      optionSelected2: '',
      optionSelected3: '',
      // #endregion

      // #region Table
      tableClass: '',
      tableSearch: '',
      // tableCBSelected: [],
      headers: [
        {
          text: '品牌',
          align: 'start',
          value: 'b_name'
        },
        {
          text: '系列',
          align: 'start',
          value: 's_name'
        },
        {
          text: '型號',
          align: 'start',
          value: 'model'
        },
        {
          text: '價格',
          align: 'start',
          value: 'price'
        },
        {
          text: '漲跌',
          align: 'start',
          value: 'rf'
        },
        {
          text: '帳跌幅',
          align: 'start',
          value: 'ap'
        },
        {
          text: '',
          align: 'start',
          value: 'actions',
          sortable: false
        },
        {
          text: '更新時間',
          align: 'start',
          value: 'update_time'
        }
        // {
        //   text: '',
        //   align: 'start',
        //   value: 'actions',
        //   sortable: false
        // }
      ],
      isClickSell: false,
      // #endregion

      // #region
      // #endregion
      nothing: undefined
    }
  },
  computed: {
    ...mapState('account', ['g_id', 'user', 'uid']),
    ...mapState('forward', ['isUpdating2', 'components', 'carts', 'cartsIdxs']),
    options2() {
      const o = []
      if (!this.optionSelected1) return o
      if (this.optionSelected1.value === undefined) return o

      const id = this.optionSelected1.value
      this.components.brand.forEach(e => {
        if (e.l_id === id) o.push(e)
      })
      if (o.length > 0) o.unshift({ text: '所有品牌', value: 0 })
      return o
    },
    options3() {
      const o = []
      if (!this.optionSelected2) return o
      if (this.optionSelected2.value === undefined) return o

      const id = this.optionSelected2.value

      this.components.series.forEach(e => {
        if (e.b_id === id || id === 0) o.push(e)
      })
      if (o.length > 0) o.unshift({ text: '所有系列', value: 0 })
      return o
    },
    listByTwoOptions() {
      const o = []
      if (!this.optionSelected2) return o
      if (this.optionSelected2.value === undefined) return o
      if (!this.optionSelected3) return o
      if (this.optionSelected3.value === undefined) return o

      const b_id = this.optionSelected2.value
      const s_id = this.optionSelected3.value

      this.components.detail.forEach(e => {
        if (
          (e.b_id === b_id || b_id === 0) &&
          (e.s_id === s_id || s_id === 0)
        ) {
          o.push(e)
        }
      })

      return o
    }
  },
  methods: {
    ...mapActions('forward', ['getComponentsByOption']),
    ...mapMutations('forward', ['addToCarts']),
    // #region Component Options
    handleOnChangeOption1() {
      if (!this.optionSelected1) return
      if (!this.optionSelected1.value) return
      ;(async () => {
        for (let i = 0; i < this.components.list.length; i++) {
          if (this.components.list[i].value === this.optionSelected1.value) {
            sessionStorage.setItem('listIdx', i)
            break
          }
        }
        sessionStorage.setItem('listId', this.optionSelected1.value)
        sessionStorage.setItem('listName', this.optionSelected1.text)
        const { g_id, user, uid } = this
        await this.getComponentsByOption({
          l_id: this.optionSelected1.value,
          g_id,
          user,
          uid
        })
        this.$nextTick(async () => {
          this.optionSelected2 = this.options2[0]
          this.optionSelected3 = this.options3[0]
        })
      })()
    },
    handleOnChangeOption2() {
      this.optionSelected3 = this.options3[0]
    },
    // #endregion

    // #region Table
    handleOnSellItem(item) {
      // if (this.cartsIdxs[item.idx]) return

      item.count = 1
      item.profile = item.s_price * 1
      this.addToCarts(item)

      this.isClickSell = true
      this.$nextTick(() => {
        this.isClickSell = false
      })
    },
    getColor(v) {
      if (v > 0) return 'red'
      else if (v < 0) return 'green'
      else return ''
    },
    getColorForCart(item) {
      if (!this.cartsIdxs[item.l_id]) return ''
      if (!this.cartsIdxs[item.l_id][item.idx]) return ''
      return 'amber'
    },
    changeToPage3() {
      let paths = {
        '/page2': 'page3',
        '/memberp2': 'memberp3'
      }
      this.$emit('changePage', { path: paths[window.location.pathname] }, 2)
    }
    // #endregion
  },
  created() {
    this.$emit('setTab')
    if (this.user) {
      this.headers = [
        {
          text: '品牌',
          align: 'start',
          value: 'b_name'
        },
        {
          text: '系列',
          align: 'start',
          value: 's_name'
        },
        {
          text: '型號',
          align: 'start',
          value: 'model'
        },
        {
          text: '價格',
          align: 'start',
          value: 'price'
        },
        {
          text: '漲跌',
          align: 'start',
          value: 'rf'
        },
        {
          text: '帳跌幅',
          align: 'start',
          value: 'ap'
        },
        {
          text: '優惠價格',
          align: 'start',
          value: 's_price'
        },
        {
          text: '',
          align: 'start',
          value: 'actions',
          sortable: false
        },
        {
          text: '更新時間',
          align: 'start',
          value: 'update_time'
        }
      ]
    }

    ;(async () => {
      const { g_id, user, uid } = this
      await this.getComponentsByOption({
        l_id: sessionStorage.getItem('listId'),
        g_id,
        user,
        uid
      })

      if (!sessionStorage.getItem('listId')) {
        const item = this.components.list[0]
        sessionStorage.setItem('listIdx', 0)
        sessionStorage.setItem('listId', item.value)
        sessionStorage.setItem('listName', item.text)
      }

      this.$nextTick(async () => {
        const idx = sessionStorage.getItem('listIdx')
        this.optionSelected1 = this.components.list[idx]

        if (this.options2.length < 1) return
        this.optionSelected2 = this.options2[0]

        if (this.options3.length < 1) return
        this.optionSelected3 = this.options3[0]
      })
    })()
    // #region
    // #endregion
  }
}
</script>

<style lang="scss">
.my-page2-table {
  background-color: rgba(37, 37, 37, 0.9) !important;
  padding-left: 10px;
  padding-right: 10px;

  th {
    vertical-align: top !important;
  }

  th,
  td {
    font-size: 18px;
    padding-right: 2px !important;
    padding-left: 2px !important;
  }
}

.my-page3-tbft-append {
  background-color: rgba(37, 37, 37, 0.9) !important;
  padding-right: 8px !important;
  padding-bottom: 10px !important;
}

@media screen and (max-width: 600px) {
  .my-page2-card {
    .v-input {
      label {
        font-size: 22px !important;
      }

      input {
        font-size: 22px !important;
      }
    }
  }

  .my-page2-table {
    .v-input {
      label {
        font-size: 22px;
      }
    }

    table {
      // padding-left: 5px;
      // padding-right: 5px;

      th,
      td {
        font-size: 24px;
      }

      .v-btn {
        font-size: 20px;
        height: 70px !important;
        .v-btn__content {
          writing-mode: vertical-lr !important;
        }
      }
    }
  }
}
</style>
